<script lang="ts">
    import KpVerticalSeparator from 'shared/ui-widgets/separator/KpVerticalSeparator.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
</script>

<div class="threads-list">
    <span class="heading-text">Vlákna</span>

    <KpVerticalSeparator height="12px"/>

    <KpButton buttonSize="xs" buttonStyle="success-new">
        <IconedContent icon="add">Nové vlákno</IconedContent>
    </KpButton>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .threads-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        column-gap: @spacing-m;
        row-gap: @spacing-sm;
        padding: @spacing-ml;
        border-bottom: 1px solid @themed-border-default;

        .heading-text {
            font-weight: 500;
        }
    }
</style>